<template>
  <transition name="fade-in">
    <div :class="{ 'processing': processing }">
      <div v-if="processing" class="loading-state">
        <div class="loading"></div>
      </div>
      <div v-if="!processing" class="loader" :class="{ 'light-loader': light, 'orange-loader': orange, 'relative': relative }">
        <div class="loader-figure"></div>
      </div>
      <slot v-if="processing"></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Preloader",
  props: ["light", "orange", "relative", "processing"]
};
</script>
<style lang="scss">
$blue: #3caaca;
$white: #fff;
$orange: #f18757;

.loader,
.loader-figure {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &.relative {
    margin: 0 auto;
    transform: translate(0, 0);
    left: 0;
    top: 0;
  }
}

.loader {
  overflow: visible;
  padding-top: 2em;
  height: 0;
  width: 2em;

  &-figure {
    height: 0;
    width: 0;
    box-sizing: border-box;
    border: 0 solid $blue;
    border-radius: 50%;
    animation: loader-figure 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  &.light-loader {
    .loader-figure {
      border-color: $white;
    }
  }

  &.orange-loader {
    .loader-figure {
      border-color: $orange;
    }
  }
}

@keyframes loader-figure {
  0% {
    height: 0;
    width: 0;
  }

  30% {
    height: 2em;
    width: 2em;
    background-color: transparent;
    border-width: 1em;
    opacity: 1;
  }

  100% {
    height: 2em;
    width: 2em;
    border-width: 0;
    opacity: 0;
    background-color: transparent;
  }
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 8px solid #ddd;
  border-top-color: #959595;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
</style>